"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.settingsV1 = exports.settings = exports.name = exports.metadata = void 0;
Object.defineProperty(exports, "settingsV2", {
  enumerable: true,
  get: function () {
    return _v.default;
  }
});

var _i18n = require("@wordpress/i18n");

var _icons = require("@wordpress/icons");

var _deprecated = _interopRequireDefault(require("./deprecated"));

var _edit = _interopRequireDefault(require("./edit"));

var _save = _interopRequireDefault(require("./save"));

var _transforms = _interopRequireDefault(require("./transforms"));

var _v = _interopRequireDefault(require("./v2"));

/**
 * WordPress dependencies
 */

/**
 * Internal dependencies
 */
const metadata = {
  $schema: "https://schemas.wp.org/trunk/block.json",
  apiVersion: 2,
  name: "core/quote",
  title: "Quote",
  category: "text",
  description: "Give quoted text visual emphasis. \"In quoting others, we cite ourselves.\" \u2014 Julio Cort\xE1zar",
  keywords: ["blockquote", "cite"],
  textdomain: "default",
  attributes: {
    value: {
      type: "string",
      source: "html",
      selector: "blockquote",
      multiline: "p",
      "default": "",
      __experimentalRole: "content"
    },
    citation: {
      type: "string",
      source: "html",
      selector: "cite",
      "default": "",
      __experimentalRole: "content"
    },
    align: {
      type: "string"
    }
  },
  supports: {
    anchor: true,
    __experimentalSlashInserter: true,
    __experimentalOnEnter: true,
    typography: {
      fontSize: true,
      lineHeight: true,
      __experimentalFontStyle: true,
      __experimentalFontWeight: true,
      __experimentalLetterSpacing: true,
      __experimentalTextTransform: true,
      __experimentalDefaultControls: {
        fontSize: true,
        fontAppearance: true
      }
    },
    color: {
      gradients: true,
      link: true,
      __experimentalDefaultControls: {
        background: true,
        text: true
      }
    }
  },
  styles: [{
    name: "default",
    label: "Default",
    isDefault: true
  }, {
    name: "plain",
    label: "Plain"
  }],
  editorStyle: "wp-block-quote-editor",
  style: "wp-block-quote"
};
exports.metadata = metadata;
const {
  name
} = metadata;
exports.name = name;
const settingsV1 = {
  icon: _icons.quote,
  example: {
    attributes: {
      value: '<p>' + (0, _i18n.__)('In quoting others, we cite ourselves.') + '</p>',
      citation: 'Julio Cortázar'
    }
  },
  transforms: _transforms.default,
  edit: _edit.default,
  save: _save.default,

  merge(attributes, _ref) {
    let {
      value,
      citation
    } = _ref;

    // Quote citations cannot be merged. Pick the second one unless it's
    // empty.
    if (!citation) {
      citation = attributes.citation;
    }

    if (!value || value === '<p></p>') {
      return { ...attributes,
        citation
      };
    }

    return { ...attributes,
      value: attributes.value + value,
      citation
    };
  },

  deprecated: _deprecated.default
};
exports.settingsV1 = settingsV1;
let settings = settingsV1;
exports.settings = settings;

if (process.env.IS_GUTENBERG_PLUGIN) {
  var _window;

  exports.settings = settings = (_window = window) !== null && _window !== void 0 && _window.__experimentalEnableQuoteBlockV2 ? _v.default : settingsV1;
}
//# sourceMappingURL=index.js.map